export default __webpack_public_path__ + "static/media/27.46a47524.png";